import ListShop from './ListSop.view';

export default ListShop;
